import {
  SET_PARENT_FORM_FIELD,
  SET_PARENT_FORM
} from 'actions/account/parents/actionTypes'

const form = (state = {}, action) => {
  switch (action.type) {
    case SET_PARENT_FORM_FIELD:
      return Object.assign({}, state, { [action.field]: action.value })
    case SET_PARENT_FORM:
      return action.data
    default:
      return state
  }
}

export default form
